<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
      <div v-if="props.row.gamme_produit !== null" slot="gamme_produit.libelle" slot-scope="props" class="slot-gamme_produit">
        <span>{{ props.row.gamme_produit.libelle }}</span>
      </div>
      <div v-else class="slot-gamme_produit">
        <span>Général</span>
      </div>
      <div v-if="props.row.date_debut" slot="date_debut" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_debut) }}</span>
      </div>
      <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_fin) }}</span>
      </div>
      <div v-if="props.row.date_publication_journal_officiel" slot="date_publication_journal_officiel" slot-scope="props" class="slot-date">
        <span class="badge badge-success p-2">{{ formatDate(props.row.date_publication_journal_officiel) }}</span>
      </div>
      <div slot="action" slot-scope="props">
        <i v-b-tooltip.hover.lefttop title="Voir le document" class="fa fa-eye fa-1_5x text-primary clickable mr-1" @click="showFicheDocument(props.row)"></i>
        <i v-if="canEditDocument() && props.row.status.libelle_technique !== 'document_archive'" v-b-tooltip.hover title="Modifier le document" class="fa fa-edit fa-1_5x text-success clickable mr-1" @click="editDocument(props.row)"></i>
        <i v-else v-b-tooltip.hover.lefttop title="" class="fa fa-edit fa-1_5x text-secondary mr-1"></i>
        <i v-if="!isEmptyChemin(props.row.chemin)" v-b-tooltip.hover.lefttop title="Télécharger le fichier" class="fa fa-download fa-1_5x text-warning mr-1" @click="downloadFichier(props.row)"></i>
        <i v-if="isEmptyChemin(props.row.url) && isEmptyChemin(props.row.chemin)" v-b-tooltip.hover.lefttop title="Aucun fichier" class="fa fa-download fa-1_5x text-secondary mr-1"></i>
        <i v-if="!isEmptyChemin(props.row.url)" v-b-tooltip.hover.lefttop title="Vidéo" class="fa fa-video-camera fa-1_5x text-secondary mr-1"></i>

      </div>
      <div slot="selection" slot-scope="props">
        <b-form-checkbox
          v-model="selectedRows"
          :value="props.row.id"
          :state="errors.checkbox === ''">
        </b-form-checkbox>
      </div>
      <div slot="h__selection">
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          aria-describedby="items"
          aria-controls="items"
          @change="toggleAll">
        </b-form-checkbox>
      </div>
      <div slot="afterTable">
      <b-row>
        <b-col sm="12">
          <span class="field-error inline mr-1 float-right">{{ errors.checkbox }}</span>
        </b-col>
      </b-row>
      <div v-if="canManageDocument()" style="float:right;display:inline-block;">
        <b-button type="button" @click="openModal()" class="pull-right ml-1 mr-1 mt-1"
            size="md" variant="warning">
          <i class="fa fa-paper-plane" title="Envoyer les documents par mail"></i> Envoyer par mail
        </b-button>
      </div>
    </div>
    </v-server-table>

    <modal-document :selectedDocument="selectedDocument"></modal-document>

    <b-modal size="xl" centered scrollable id="modal-fiche-document" ref="modal-fiche-document" :header-bg-variant="headerBgVariant()">
      <template #modal-header>
        <div class="w-100">
          <h5 class="d-inline-block">Détails du document : <label style="color:#9c3c05">{{ selectedDocument.libelle }}</label> </h5>
          <button type="button" aria-label="Close" class="close pull-right" @click="$bvModal.hide('modal-fiche-document')">×</button>
          <span class="pull-right mr-4"> {{ stateForm }}</span>
        </div>
      </template>
    <!-- <b-modal size="xl" centered title="FICHE DOCUMENT" id="modal-fiche-document" ref="modal-fiche-document"> -->
      <b-tabs content-class="">
        <b-tab active>
          <template #title>Détails document</template>
          <details-document :selectedDocument="selectedDocument"></details-document>
        </b-tab>
        <b-tab>
          <template #title>Historique document</template>
          <historique-document :selectedDocument="selectedDocument" :datas="datas"></historique-document>
        </b-tab>
        <b-tab>
          <template #title>Fichiers du document</template>
          <fichiers-document :selectedDocument="selectedDocument"></fichiers-document>
        </b-tab>
      </b-tabs>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            class="float-right ml-2"
            @click="$bvModal.hide('modal-fiche-document')">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal size="xl" centered no-close-on-esc no-close-on-backdrop hide-header-close title="Envoi de documents par mail" id="modal-mail-to" ref="modal-mail-to">
      <b-form>
        <b-row>
          <b-col sm="1">
            <label for="mailTo">A :</label>
          </b-col>
          <b-col sm="6">
            <b-form-group description='Pour plusieurs destinataires, séparer les adresses mail par un ";"'>
              <b-form-input id="mailTo" type="text" :class="{hasError: errors.mailTo !== ''}"
                v-model="mailTo"></b-form-input>
              <span class="field-error">{{ errors.mailTo }}</span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col sm="1">
            <label for="mailCc">Cc :</label>
          </b-col>
          <b-col sm="6">
            <b-form-group description='Pour plusieurs destinataires, séparer les adresses mail par un ";"'>
              <b-form-input id="mailCc" type="text" v-model="mailCc"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="1">
            <label for="contentBody">Message :</label>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <b-form-textarea id="contentBody" v-model="contentBody"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            class="float-right ml-2"
            @click="sendMail()">
            <i class="fa fa-paper-plane"></i>
            Envoyer
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-mail-to')">
            Annuler
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
  import { downloadFile, isEmpty } from "@/utils/fileHelper"
  import DetailsDocument from "./DetailsDocument"
  import HistoriqueDocument from "./HistoriqueDocument"
  import FichiersDocument from "./FichiersDocument"
  import ModalDocument from "@/views/espaceBibliotheque/documents/ModalDocument.vue"
  import { espaceBibliothequeRules as rules, hasRule } from '@/utils/rulesHelper'

  export default {
    name: "DocumentsTable",
    components: {
      DetailsDocument,
      HistoriqueDocument,
      FichiersDocument,
      ModalDocument,
    },
    props: ["tableEntry", 'datas'],
    data() {
      let self = this;
      return {
        url: '',
        columns: ['libelle', 'gamme_produit.libelle', 'code', 'version', 'status.libelle_bo', 'date_debut', 'date_fin', 'date_publication_journal_officiel', 'action', 'selection'],
        options: {
          headings: {
            libelle: 'Libellé',
            'gamme_produit.libelle': 'Famille Produit',
            code: 'Code',
            version: 'Version',
            'status.libelle_bo': 'Statut',
            date_debut: 'Date début',
            date_fin: 'Date fin',
            date_publication_journal_officiel: 'Date de publication',
            action: '#',
            selection: '',
          },
          columnsClasses: {
            action: 'document-action',
            selection: 'align-middle text-center position-r'
          },
          cellClasses:{
            'status.libelle_bo': [
              {
                class:'document-publie',
                condition: row => !isEmpty(row.status) && row.status.libelle_technique === 'document_publie'
              },
              {
                class:'document-brouillon',
                condition: row => !isEmpty(row.status) && row.status.libelle_technique === 'document_brouillon'
              },
              {
                class:'document-archive',
                condition: row => !isEmpty(row.status) && row.status.libelle_technique === 'document_archive'
              }
            ]
          },
          sortable: ['libelle', 'version'],
          filterable: ['libelle', 'code'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {filterPlaceholder: "Libellé, Code"},
          orderBy: {column: 'libelle', ascending: false},
          requestFunction: function (data) {
            self.url = '/espaceBibliotheque/documents/recherche'
            data['libelle'] = self.tableEntry.libelle
            data['code'] = self.tableEntry.code
            data['version'] = self.tableEntry.version
            data['date_debut'] = self.tableEntry.date_debut
            data['date_fin'] = self.tableEntry.date_fin
            data['date_publication_journal_officiel'] = self.tableEntry.date_publication_journal_officiel
            data['oap'] = self.tableEntry.oap.map(item => item.id)
            data['oag'] = self.tableEntry.oag.map(item => item.id)
            data['categorie'] = self.tableEntry.categorie
            data['type'] = self.tableEntry.type
            data['gamme'] = self.tableEntry.gamme
            data['garantie'] = self.tableEntry.garantie.map(item => item.value)
            data['rubrique'] = self.tableEntry.rubrique
            data['sousRubrique'] = self.tableEntry.sousRubrique
            data['segment'] = self.tableEntry.segment
            data['status'] = self.tableEntry.status
            data['is_visible_client'] = self.tableEntry.is_visible_client
            data['secteur'] = self.tableEntry.secteur
            data['noSearch'] = self.tableEntry.noSearch
            self.$store.commit("IS_LOADING", true);
            return axios.get(self.url, {
              params: data
            })
            .then(function (response) {
              self.$store.commit('IS_LOADING', false)
              return response;
            })
            .catch(function (e) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            }.bind(this));
          },
        },
        allSelected: false,
        selectedRows: [],
        indeterminate: false,
        errors: {
          checkbox: '',
          mailTo: '',
          contentBody: '',
        },
        mailTo: '',
        mailCc: '',
        contentBody: '',
        selectedDocument: null,
        rules,
        hasRule
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    mounted() {
      this.$eventBus.$on('callShowFicheDocument', (document) => {
        this.showFicheDocument(document)
      })
      this.$eventBus.$on('callEditDocument', (document) => {
        this.editDocument(document)
      })
      this.$eventBus.$on('callDownloadFichier', (document) => {
        this.downloadFichier(document)
      })
    },
    watch: {
      selectedRows(newVal, oldVal) {
        // Handle changes in individual checkboxes
        if (newVal.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newVal.length === this.$refs.table.data.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
      }
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      editDocument(selectedDocument) {
        if (!isEmpty(selectedDocument)) {
          this.selectedDocument = selectedDocument;
        } else {
          this.selectedDocument = null
          this.$event.emit('open-add-document')
        }
        this.$bvModal.show('modal-document')
      },
      formatDate(textDate) {
        let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
        return date;
      },
      downloadFichier(selectedDocument) {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceBibliotheque/document/fichier/download/' + selectedDocument.id, {responseType: 'arraybuffer'})
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, selectedDocument.nom_fichier, selectedDocument.extension);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      headerBgVariant() {
        if (this.selectedDocument && !isEmpty(this.selectedDocument.status)) {
          if (this.selectedDocument.status.libelle_technique == 'document_brouillon') {
            this.stateForm = 'Brouillon'
            return 'warning'
          } else if (this.selectedDocument.status.libelle_technique == 'document_publie') {
            this.stateForm = 'Publié'
            return 'primary'
          } else {
            this.stateForm = 'Archivé'
            return 'secondary'
          }
        } else {
          this.stateForm = 'Aucun statut'
          return
        }
      },
      showFicheDocument(selectedDocument) {
        this.selectedDocument = selectedDocument
        this.$bvModal.show('modal-fiche-document')
      },
      isEmptyChemin(chemin) {
        return isEmpty(chemin);
      },
      toggleAll(checked) {
        this.selectedRows = checked ? this.$refs['table'].data.map(item => {
          return item.id
        }) : []
      },
      openModal() {
        if (this.selectedRows.length == 0) {
          this.errors.checkbox = 'Vous devez choisir au moins un document.'
        } else {
          this.errors.checkbox = ''
          this.$refs['modal-mail-to'].show();
        }
      },
      validateData() {
        let valid = true
        if (this.mailTo === "") {
          this.errors.mailTo = "Le destinataire est obligatoire"
          valid = false
        }
        return valid
      },
      sendMail() {
        if (this.validateData()) {
          let self = this;
          this.$store.commit('IS_LOADING', true);
          let dataPost = {};
          dataPost.documentIds = this.selectedRows
          dataPost.mailTo = this.mailTo
          dataPost.mailCc = this.mailCc
          dataPost.contentBody = this.contentBody
          this.$axios
            .post('/espaceBibliotheque/document/sendMail', dataPost)
            .then((response) => {
              this.$store.commit('IS_LOADING', false);
              this.$refs['modal-mail-to'].hide();
              this.$swal({
                position: 'top',
                type: 'success',
                title:'Envoi de mail avec succès',
                text:'Les documents sélectionnés ont bien été envoyés',
                showConfirmButton: false,
                timer: 5000
              })
            })
            .catch(function (error) {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      canEditDocument() {
        return hasRule(rules.CAN_EDIT_DOCUMENT);
      },
      canManageDocument() {
        return hasRule(rules.CAN_MANAGE_BIBLIOTHEQUE);
      },
    }
  }
</script>

<style>
  .document-publie {
    color: #fff;
    background-color: #20a8d8;
  }
  .document-brouillon {
    color: #fff;
    background-color: #ffc107;
  }
  .document-archive {
    color: #fff;
    background-color: #c8ced3;
  }
</style>
